import { render } from "./CustomTemplate.vue?vue&type=template&id=0398c5c8"
import script from "./CustomTemplate.vue?vue&type=script&lang=js"
export * from "./CustomTemplate.vue?vue&type=script&lang=js"

import "./CustomTemplate.vue?vue&type=style&index=0&id=0398c5c8&lang=css"
script.render = render

export default script